import React from "react";
import { Link } from "react-router-dom";

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Link to="/" data-testid="site-logo" title="KMT Private Rides (placeholder logo until the final file arrives)" className="group inline-flex min-h-[48px] items-center gap-3">
      <span className="grid h-11 w-11 place-items-center rounded-full border border-gold/80 bg-ink font-display text-[14px] font-bold tracking-wider text-gold transition-colors duration-200 group-hover:bg-plum">
        KMT
      </span>
      {!compact && (
        <span className="flex flex-col leading-tight">
          <span className="font-display text-[15px] font-semibold tracking-[0.18em] text-mist">KMT</span>
          <span className="font-display text-[14px] tracking-[0.2em] text-gold">PRIVATE RIDES</span>
        </span>
      )}
    </Link>
  );
}
